


interface IGetTokenRequest {
    tenantId: string,
    name: string,
    email: string;
}
interface IGetTokenResponse {
    token: string,
    userId: string,
    conversationId: string,
    user: IGetTokenRequest;
}



export class ChimeApi {
    private static apiRoot:string = (document.getElementById("ApiRoot")as HTMLInputElement)?.value ?? "";

    static ApiRoot(): string {
        if (this.apiRoot) {
            const apiRoot = this.apiRoot.endsWith('/') ? this.apiRoot.slice(0, -1) : this.apiRoot;
            return apiRoot;
        }
        return "";
    }
    static SiteName(): string {
        return (document.getElementById("SiteName")as HTMLInputElement)?.value ?? "Chime";
    }

    static async getToken(args: IGetTokenRequest): Promise<IGetTokenResponse> {
        const requestVerificationToken = (document.getElementById("RequestVerificationToken")as HTMLInputElement)?.value;
        const data = args as any;
        // it is probably unnecessary to put the token in the payload, when we are also sending it in the header
        // but the code to put it in the header has been there since before the [IgnoreAntiforgeryToken] attribute was added to the controller
        // and so maybe it didn't work correctly as a header.  We do the __RequestVerificationToken in the payload all over the place and it works.
        data.__RequestVerificationToken = requestVerificationToken;
        
        const body = JSON.stringify(data);
        console.log("getToken request: ", body);

        let url = "/chat/getToken";
        if (this.apiRoot) {
            url = this.ApiRoot() + url;
        }
        
        const response = await fetch(url,
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    RequestVerificationToken:
                        requestVerificationToken
                },
                body: body
            });

        const json = await response.json();
        return json;
    }
}